'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../dist-es6/client/formatters');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseRealtimeUpdateController=require('../../../../dist-es6/client/angularCommon/baseRealtimeUpdateController');
const{UpdateFailedError:UpdateFailedError}=BaseRealtimeUpdateController;
const{SocketTimeoutError:SocketTimeoutError,UnexpectedError:UnexpectedError}=require('../../../../dist-es6/client/services/socketService');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const{HandleUncaughtErrors:HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const FatigueMeterType=require('../../../../dist-es6/shared/domain/fatigueMeterType');

const ControllerDefaults={
stateName:'fdc.features.forecast',
searchQuery:'',
maxSchedulesToDisplay:100,
selectedSchedule:null,
preventRealtimeDigests:!0,
excludeLowFatigueHistory:!1,
hideSortPreference:!0,
showAlertingOnly:!0,
showActiveOnly:!0};


const ForecastTopMargin=25;let

ForecastController=(_class=function(_BaseRealtimeUpdateCo){_inherits(ForecastController,_BaseRealtimeUpdateCo);
function ForecastController(
$scope,
$state,
$timeout,
$interval,
$element,
dateService,
breadcrumbsService,
forecastDataService,
userService,
Analytics,
uncaughtErrorHandler,
groupTreeService,
timeZoneService,
timeFormattingService,
paramSyncService,
displaySettingsService)
{_classCallCheck(this,ForecastController);var _this=_possibleConstructorReturn(this,
_BaseRealtimeUpdateCo.call(this,uncaughtErrorHandler,$scope,$timeout,$interval,dateService,timespan.fromMinutes(5),timespan.fromSeconds(1),timeZoneService));

const existingStickySettings={};

const showAlertingOnly=displaySettingsService.stickySettings.get('showAlertingOnly');
if(_.exists(showAlertingOnly)){
existingStickySettings.showAlertingOnly=showAlertingOnly;
}

const showActiveOnly=displaySettingsService.stickySettings.get('showActiveOnly');
if(_.exists(showActiveOnly)){
existingStickySettings.showActiveOnly=showActiveOnly;
}

_.defaults(_this,existingStickySettings,ControllerDefaults);

_this._$timeout=$timeout;
_this._$state=$state;
_this._$element=$element;

_this._uncaughtErrorHandler=uncaughtErrorHandler;
_this._forecastDataService=forecastDataService;
_this._userService=userService;
_this._analytics=Analytics;
_this._timeFormattingService=timeFormattingService;
_this._displaySettingsService=displaySettingsService;

_this._timeZoneService=timeZoneService;
_this.selectedSchedule=null;
_this.selectedScheduleAlertInfo=null;

breadcrumbsService.startTrail('Forecast');
groupTreeService.linkController(_this);

_this.sortOptions=[{
label:'Bucketed',
sortBy:_bucketedForecastSort},
{
label:'Alert Start Time',
sortBy:_alertStartTimeSort},
{
label:'Future Alert Duration',
sortBy:_futureDurationSort},
{
label:'Total Alert Duration',
sortBy:_totalAlertDurationSort}];


_this.selectedSortOption=_this.sortOptions[0];

_this._updateUrlParamsFromController=paramSyncService.start(_this,$scope,function(newParams){return _this._updateControllerParamsFromUrl(newParams)});

if($state.params.groupId||$state.params.employeeId){
_this._$timeout(function(){return _this._assignParamsToController($state.params)});
}

_this._$scope.$watch('controller.selectedSchedule',function(newVal,oldVal){
_this._updateUrlParamsFromController({
personId:_.result(_this.selectedSchedule,'id.toString')});


if(!_.exists(_this.selectedSchedule)){
_this.sidebarVisible=!1;
return;
}

_this.sidebarVisible=!0;
});

_this.useFixedAxisPosition=!1;

_this._onScrollHandler=function(scope){let{scrollTop:scrollTop}=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};
const useFixedAxisPosition=scrollTop>=ForecastTopMargin;

if(useFixedAxisPosition===_this.useFixedAxisPosition){
return;
}

_this._$scope.$evalAsync(function(){
_this.useFixedAxisPosition=useFixedAxisPosition;
});
};

_this._$scope.$watchGroup([
'controller.selectedGroupData',
'controller.showAlertingOnly',
'controller.showActiveOnly',
'controller.selectedSortOption'],
function(){

if(_.exists(_this.showAlertingOnly)){
_this._displaySettingsService.stickySettings.set('showAlertingOnly',_this.showAlertingOnly);
}

if(_.exists(_this.showActiveOnly)){
_this._displaySettingsService.stickySettings.set('showActiveOnly',_this.showActiveOnly);
}

const persons=_.get(_this,'selectedGroupData.aggregatePersons',[]);
if(!persons.length){
_this.forecastSchedules=[];
_this.selectedSchedule=null;
return;
}

_this.forecastSchedules=_this._filterAndSort(persons);
const selectedScheduleId=_.result(_this.selectedSchedule,'id.toString',_this._$state.params.personId);
const newSelectedScheduleWithSameId=selectedScheduleId&&_this.forecastSchedules.find(function(s){return s.id.toString()===selectedScheduleId});

_this._$scope.$evalAsync(function(){
_this.selectedSchedule=newSelectedScheduleWithSameId||null;

_this._$timeout(function(){

const scrollerElement=angular.element('.feature-main > .scroller-wrapper.forecast-schedules');
if(!scrollerElement){
return;
}

scrollerElement.triggerHandler('mouseenter');

if(!newSelectedScheduleWithSameId){
scrollerElement.scrollTop(0);
}
});
});
});

_this._$scope.$watch('controller.searchQuery',_.debounce(function(){

_this._$timeout(function(){
const scrollerElement=angular.element('.feature-main > .scroller-wrapper.forecast-schedules');
if(!scrollerElement){
return;
}

scrollerElement.triggerHandler('mouseenter');
scrollerElement.scrollTop(0);
});
},150));

_this._$scope.$watch('controller.filteredSchedules',function(){

if(!_this.selectedSchedule){
return;
}

if(_this.filteredSchedules.indexOf(_this.selectedSchedule)!==-1){
return;
}

_this._$scope.$evalAsync(function(){
_this.selectedSchedule=null;
});
});

_this._beginUpdates();return _this;
}ForecastController.prototype.

_filterAndSort=function _filterAndSort(persons){var _this2=this;
let filteredPersons=_(persons);

if(this.showActiveOnly){
filteredPersons=filteredPersons.
filter(function(p){return p.workdayStart!==null&&_.get(p,'forecast.schedule.duties',[]).some(function(d){return _this2._forecastDataService.forecastRange.intersects(d)})}).
filter(function(p){return _.result(p,'predictedWorkday.end.getTime',-1)>=_this2._forecastDataService.currentTimeForForecast.getTime()});
}

if(this.showAlertingOnly){
const futurePeriodPredictionInterval=TimeInterval.from(this._forecastDataService.currentTimeForForecast).to(this._forecastDataService.forecastRange.end);
filteredPersons=filteredPersons.
filter(function(p){
const aboveThresholdIntervals=_.get(p,'visibleAlertRanges.past.Above',[]).concat(_.get(p,'visibleAlertRanges.future.Above',[]));
if(aboveThresholdIntervals.length===0){
return!1;
}

const futureAboveThresholdIntervals=TimeInterval.clip(aboveThresholdIntervals).to(futurePeriodPredictionInterval);

return futureAboveThresholdIntervals.length!==0;
});
}

return filteredPersons.
sortBy(this.selectedSortOption.sortBy).
value();
};ForecastController.prototype.

_assignParamsToController=function _assignParamsToController(params){
if(this.forecastSchedules){
this.selectedSchedule=this.forecastSchedules.find(function(s){return s.id.toString()===params.personId});
}
this._groupTreeService.selectGroupWithId(params.groupId);
};ForecastController.prototype.

_updateControllerParamsFromUrl=function _updateControllerParamsFromUrl(newStateParams){
let{groupId:groupId,personId:personId}=newStateParams;

if(_.get(this.selectedGroup,'id')===groupId&&
_.get(this.selectedSchedule,'id')===personId){
return;
}

this._assignParamsToController(newStateParams);
};ForecastController.prototype.


















_update=function(){var ref=_asyncToGenerator(function*(){
try{
yield this.dataService.update({excludeLowFatigueHistory:this.excludeLowFatigueHistory});
}catch(err){
if(err instanceof SocketTimeoutError||err instanceof UnexpectedError){
throw new UpdateFailedError;
}
throw err;
}
});function _update(){return ref.apply(this,arguments)}return _update}();_createClass(ForecastController,[{key:'use24HourTimeline',get:function(){return this._timeFormattingService.safeUse24HourTimelineSetting}},{key:'groupTreeService',get:function(){return this._groupTreeService},set:function(groupTreeService){this._groupTreeService=groupTreeService}},{key:'dataService',get:function(){return this._forecastDataService}},{key:'$state',get:function()

{
return this._$state;
}},{key:'$scope',get:function()

{
return this._$scope;
}},{key:'_lastFetchTime',get:function()

{
return this._forecastDataService.lastFetchTime;
}},{key:'_isUpdating',get:function()

{
return this._forecastDataService.isUpdating;
}},{key:'groupTree',get:function()

{
return this._forecastDataService.groupTree;
}},{key:'estimatesAsOfTime',get:function()

{
return this._forecastDataService.estimatesAsOfTime;
}},{key:'selectedGroup',get:function()

{
return this._groupTreeService.selectedGroup;
}},{key:'selectedGroupData',get:function()

{
return this._forecastDataService.selectedGroupData;
}},{key:'currentTimeForForecast',get:function()

{
return this._forecastDataService.currentTimeForForecast;
}},{key:'forecastRange',get:function()

{
return this._forecastDataService.forecastRange;
}},{key:'localTimeZone',get:function()

{
return this._timeZoneService.localTimeZone;
}}]);return ForecastController}(BaseRealtimeUpdateController),(_applyDecoratedDescriptor(_class.prototype,'_update',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_update'),_class.prototype)),_class);


const _sortUrgentToTop=function(p){return _.get(p,'currentAlertInfo.urgent',!1)?0:1};

const _getCombinedDurationFor=function(person,prop){return _.get(person,prop,[]).reduce(function(sum,ti){return sum+=ti.duration.totalMilliseconds()},0)};
const _sortTruncatedToBottom=function(p){return _.get(p,'timeOfLastPointBeforeTruncation',!1)?1:0};
const _isCurrentlyOnDuty=function(p){return _.get(p,'lastKnownStatus.onDuty',_.get(p,'effectiveStatus.onDuty',!1))?0:1};

const _getFirstVisibleAlertStartTimeSorter=function(subType){return function(p){return _.result(p,`visibleAlertRanges.${subType}[0].start.getTime`,Infinity)}};

const _workdayBucketSort=function(p){return p.predictedWorkday?
p.predictedWorkday.contains(p.currentTimeForForecast)?
0:
1:
2};

const _nowOrFutureBucketer=function(p,alertType,score,next){
const firstStartTime=_.result(p,`visibleAlertRanges.future.${alertType}[0].start.getTime`);
if(_.exists(firstStartTime)){
if(firstStartTime===p.currentTimeForForecast.getTime()){
if(_.get(p,'lastKnownStatus.onDuty',_.get(p,'effectiveStatus.onDuty',!1))){
return score+0;
}
return score+1;
}
return score+2;
}
return next(p,score+3);
};

const _pastBucketer=function(p,alertType,score,next){
const firstStartTime=_.result(p,`visibleAlertRanges.past.${alertType}[0].start.getTime`);
if(_.exists(firstStartTime)){
return score+0;
}
return next(p,score+1);
};

const _timeAndTypeOfAlertBucketSort=function(p){
return _nowOrFutureBucketer(p,'Above',0,
function(p,score){return _nowOrFutureBucketer(p,'At',score,

function(p,score){return _pastBucketer(p,'Above',score,
function(p,score){return _pastBucketer(p,'At',score,

function(p,score){return score})})})});
};

const _bucketedForecastSort=[
_workdayBucketSort,
_timeAndTypeOfAlertBucketSort,
_sortTruncatedToBottom,
_getFirstVisibleAlertStartTimeSorter('future.Above'),
_getFirstVisibleAlertStartTimeSorter('past.Above'),
_getFirstVisibleAlertStartTimeSorter('future.At'),
_getFirstVisibleAlertStartTimeSorter('past.At'),
function(p){return _.result(p,'predictedWorkday.end.getTime',0)}];


const _originalFinalSort=[
_sortTruncatedToBottom,

function(p){
const futureStatusStartTimes={
Above:_.result(p,'visibleAlertRanges.future.Above[0].start.getTime'),
At:_.result(p,'visibleAlertRanges.future.At[0].start.getTime'),
Below:_.result(p,'visibleAlertRanges.future.Below[0].start.getTime')};


if(!futureStatusStartTimes.Above&&!futureStatusStartTimes.At){
return Infinity;
}

return _.min([futureStatusStartTimes.Above,futureStatusStartTimes.At]);
},

_sortUrgentToTop,

_getFirstVisibleAlertStartTimeSorter('past.Above'),
_getFirstVisibleAlertStartTimeSorter('past.At'),

function(p){return _.result(p,'alertRanges.Above[0].start.getTime')},
function(p){return _.result(p,'alertRanges.At[0].start.getTime')},

_isCurrentlyOnDuty,

function(p){return _.result(p,'forecast.schedule.duties[0].start.getTime')},

function(p){return _.result(p,'visibleAlertRanges.past.Below[0].start.getTime')||_.result(p,'visibleAlertRanges.past.NotApplicable[0].start.getTime')}];



const _alertStartTimeSort=[
_getFirstVisibleAlertStartTimeSorter('future.Above')].concat(
_originalFinalSort);


const _futureDurationSort=[
_sortUrgentToTop,
function(p){return-1*_getCombinedDurationFor(p,'visibleAlertRanges.future.Above')},
function(p){return-1*_getCombinedDurationFor(p,'visibleAlertRanges.future.At')}].concat(
_originalFinalSort);


const _totalAlertDurationSort=[
_sortUrgentToTop,
function(p){return-1*(_getCombinedDurationFor(p,'visibleAlertRanges.future.Above')+_getCombinedDurationFor(p,'visibleAlertRanges.past.Above'))},
function(p){return-1*(_getCombinedDurationFor(p,'visibleAlertRanges.future.At')+_getCombinedDurationFor(p,'visibleAlertRanges.past.At'))}].concat(
_originalFinalSort);


module.exports=ForecastController;
//# sourceMappingURL=forecastController.js.map
